import { RqmtTestList } from '@/ac/entities/rqmtTest/RqmtTestList';
import { TestRunList } from '@/ac/entities/testRun/TestRunList';
import { TitleButton } from '@/common/buttons/TitleButton';
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { ValList } from '@/common/val/ValList';
import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { useCallback, useEffect } from 'react';
import { EntityDetail } from '../../../common/entityFramework/entityDetail/EntityDetail';
import { EntityForm } from '../../../common/entityFramework/entityForm/EntityForm';
import { TestResList } from '../testRes/TestResList';

export const TestDetail = () => {

  const { entityObj, setBreadcrumbs } = useEntityMgr();
  const rsrc = useRsrc();

  const tabSpecs = [
    { id: 'infoTab', label: 'Info', content: <EntityForm /> },
    { id: 'rqmtsTab', label: 'Requirements', content: <RqmtTestList testId={entityObj.id} /> },
    { id: 'runsTab', label: 'Runs', content: <TestRunList testId={entityObj.id} /> },
    { id: 'resTab', label: 'Last Run Results', content: <TestResList testRunId={entityObj.lastTestRunId} /> },
    { id: 'valTab', label: 'Last Run Validations', content: <ValList parentEntity="TEST_RUN" parentEntityId={entityObj.lastTestRunId} /> }
  ]

  const run = useCallback(() => {
    let job = {
      name: 'Test',
      module: 'ac',
      entity: 'TEST',
      entityId: entityObj.id,
      rsrcCode: 'TEST_ACTION_PLUGIN',
      cat: 'TEST'
    }

    rsrc.save('skdr', 'JOB', job).then(job => {
      rsrc.start(job.id)
    })
  }, [entityObj.id])

  const augButtons = (buttons) => {
    buttons.push(<TitleButton icon={fas.faPlay} toolTip="Run Test" onClick={run} />);
  }

  useEffect(() => {
    if (!entityObj || entityObj.id == null) return;
    const breadCrumb = entityObj.code.replace('_', '-') + ': ' + entityObj.name;
    setBreadcrumbs([breadCrumb]); 
  }, [entityObj])

  return <EntityDetail tabSpecs={tabSpecs} augButtons={augButtons} />
}